import { BaseService } from './base.service';

export class AdapterService extends BaseService {
    baseUrl = '/adapter';
}
